import { createSlice } from '@reduxjs/toolkit';

import { resetStoresAction } from 'common/actions/common';

type PayoutSettingsState = {
  error: string;
  errorData: Object;
  isCodeValid: boolean;
  isFetching: boolean;
  message: string;
  payoutSettings:
    | {}
    | {
        id: number;
        userId: number;
        type: string;
        minimalPayout: number;
        payoutAddress: string;
        beneficiaryName: string;
        beneficiaryCountry: string;
        beneficiaryState: string;
        beneficiaryCity: string;
        beneficiaryZip: string;
        beneficiaryAddress: string;
        iban: string;
        bankName: string;
        bankRoutingNumber: string;
        swiftCode: string;
        bankCountry: string;
        correspondingBankName: string;
        correspondingBankSwift: string;
        correspondingBankAccountNumber: string;
        isConfirmed: false;
        isFilled: true;
      };
};

export type PayoutSettingsPartialState = {
  payoutSettings: PayoutSettingsState;
};

const defaultState: PayoutSettingsState = {
  error: '',
  errorData: {},
  isCodeValid: false,
  isFetching: false,
  message: '',
  payoutSettings: {},
};

const setFetching = (state: PayoutSettingsState): PayoutSettingsState => ({
  ...state,
  isFetching: true,
  message: '',
  error: '',
});

const handleSuccess = (
  state: PayoutSettingsState,
  { payload: { payoutSettings } },
): PayoutSettingsState => ({
  ...state,
  isFetching: false,
  payoutSettings,
  message: '',
  error: '',
  errorData: {},
});

const handleError = (
  state: PayoutSettingsState,
  { payload: { error, errorData = {} } },
): PayoutSettingsState => ({
  ...state,
  isFetching: false,
  message: '',
  error,
  errorData,
});

const payoutSettings = createSlice({
  name: 'payoutSettings',
  initialState: defaultState,
  reducers: {
    payoutSettingsConfirmationAction: setFetching,
    payoutSettingsFetchAction: setFetching,
    payoutSettingsUpdateAction: setFetching,
    payoutSettingsConfirmationSuccessAction: (
      state,
      { payload: { message } },
    ) => ({
      ...state,
      isFetching: false,
      isCodeValid: true,
      message,
      error: '',
    }),
    payoutSettingsFetchSuccessAction: handleSuccess,
    payoutSettingsUpdateSuccessAction: handleSuccess,
    payoutSettingsUpdateFailedAction: handleError,
    payoutSettingsConfirmationFailedAction: handleError,
    payoutSettingsResetErrorAction: (state) => ({
      ...state,
      error: '',
      errorData: {},
    }),
  },
  extraReducers: (builder) =>
    builder.addCase(resetStoresAction, () => defaultState),
});

export const {
  payoutSettingsConfirmationAction,
  payoutSettingsFetchAction,
  payoutSettingsUpdateAction,
  payoutSettingsConfirmationSuccessAction,
  payoutSettingsFetchSuccessAction,
  payoutSettingsUpdateSuccessAction,
  payoutSettingsUpdateFailedAction,
  payoutSettingsConfirmationFailedAction,
  payoutSettingsResetErrorAction,
} = payoutSettings.actions;

export default payoutSettings.reducer;
